import React, { useContext } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { Button } from '@ferris/react/components/button';
import { TrackingContext } from '@vrbo/react-event-tracking';
import TranslationUtil from '../../utils/TranslationUtil';
import luggage from '../../assets/images/how-this-works.svg';

const MAX_STEPS = 10;

const nInts = (n) => Array.from({ length: n }, (x, i) => i + 1);

const getHowItWorksSteps = (getTranslation) => (
    nInts(MAX_STEPS).map((stepNum) => ({
        title: getTranslation(`step${stepNum}.title`),
        description: getTranslation(`step${stepNum}.description`)
    })).filter((step) => step.title)
);

const getPropsFromState = (state) => {
    const { translations, fallbackTranslations } = state.app;
    const translationUtil = new TranslationUtil(translations, fallbackTranslations);
    const getTranslation = (suffix) => translationUtil.getTranslation(`Vrbo.lyp.howitworks.${suffix}`, undefined, true);

    return {
        title: getTranslation('title'),
        steps: getHowItWorksSteps(getTranslation),
        buttonLabel: getTranslation('buttonLabel')
    };
};

const renderAStep = (step, index) => (
    <div className="ulx-howitworks__item" key={`step${index}`}>
        <div className="ulx-howitworks__item__header">
            <div className="ulx-howitworks__item__number">{index + 1}</div>
            <h2>{step.title}</h2>
        </div>
        <p className="ulx-howitworks__item__description">{step.description}</p>
    </div>
);

export function LypHowItWorks() {
    const { trigger } = useContext(TrackingContext);

    const handleClick = () => {
        trigger('genericClick', {
            category: 'navigation',
            action: 'HowThisWorks: scrollButton'
        });

        // Clicks only happen client side, so no need to check for window here
        window.scrollTo(0, 0);
    };

    const { title, steps, buttonLabel } = useSelector(getPropsFromState, shallowEqual);
    return (
        <div className="ulx-howitworks" data-wdio="lyp-howitworks">
            <div className="ulx-howitworks__content">
                <div className="ulx-howitworks__content__image">
                    <img src={luggage} alt="" />
                </div>
                <div className="ulx-howitworks__maincontent" data-wdio="lyp-howitworks-steps">
                    <h1 className="ulx-howitworks__title" data-wdio="lyp-howitworks-title">{title}</h1>
                    <div className="ulx-howitworks__steps">
                        { steps.map(renderAStep) }
                        <div className="ulx-howitworks__item">
                            <Button
                                htmlButtonType="button"
                                type="primary"
                                data-wdio="next-button"
                                onClick={handleClick}
                            >
                                {buttonLabel}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

LypHowItWorks.displayName = 'LypHowItWorks';
export default LypHowItWorks;
